// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wqrotrnhigknicvdwnhl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indxcm90cm5oaWdrbmljdmR3bmhsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA5MjA4OTQsImV4cCI6MjA4NjQ5Njg5NH0.H-tq3ShQ8eBl_UCVcFLg0u4i8rSX0_bh5bS11aIBQZ0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});